/**
 * دکمه‌ی «دستِ بعد» ِ پنلِ پایانِ دست/دور — دعوت به ادامه، نه برچسبی خشک (کاربر، ۱۸ اکتبر ۲۰۲۶:
 * «برای شروعِ دستِ بعد بازیکن باید ترغیب شود»). برد: «بریم دستِ بعد!»؛ باخت: «جبرانش کن —
 * دستِ بعد»؛ تماشا یا مساوی: همان «دستِ بعد». همتای ResultKit.NextLabel در اپ.
 */
export function nextLabel(unit: "دست" | "دور", outcome: "win" | "lose" | "even"): string {
  const next = `${unit} بعد`;
  return outcome === "win" ? `بریم ${next}!` : outcome === "lose" ? `جبرانش کن — ${next}` : next;
}

/** برد یا باختِ این دست از امتیازِ همین دست (شلم پنلِ برنده ندارد): بیشترین مالِ من → برد. */
export function handOutcome(roundScore: number[], mine: (u: number) => boolean): "win" | "lose" | "even" {
  const me = roundScore.findIndex((_, u) => mine(u));
  if (me < 0 || roundScore.length < 2) return "even";
  const best = Math.max(...roundScore.filter((_, u) => u !== me));
  const my = roundScore[me]!;
  return my > best ? "win" : my < best ? "lose" : "even";
}
